import { defineStore } from 'pinia';
import notificationWrapper from '@/utils/helpers/notificationWrapper';
import servicesHelper from '@/utils/helpers/services';
import { useProjectStore } from './projectStore';
import type { Service } from '@/types/Offers';

export const useServiceStore = defineStore('service', {
  state: () => ({
    services: [],
    servicesLoading: false,
    servicesSelectedLoading: false,
    servicesPrice: 0,
  }),

  actions: {
    async postServices(services: Service[]) {
      this.servicesSelectedLoading = true;
      try {
        const projectStore = useProjectStore();
        await window.appConnector.postServices(projectStore.projectIdSelected, { services });
        this.servicesSelectedLoading = false;
      } catch (error) {
        this.servicesSelectedLoading = false;
        notificationWrapper();
        throw error;
      }
    },

    async getServices(exclTax: boolean) {
      this.servicesLoading = true;
      try {
        const projectStore = useProjectStore();
        const data = await window.appConnector.getAddServices(projectStore.projectIdSelected);
        this.setServices(Array.isArray(data) ? data : data.display);
        this.setServicesPrice({ services: this.services, exclTax });
        this.servicesLoading = false;
      } catch (error) {
        notificationWrapper();
        this.servicesLoading = false;
      }
    },

    setServices(services: Service[]) {
      this.services = services && services.map((serv) => ({
        ...serv,
        enabled: !!(serv.is_chosen && serv.value_chosen),
        value_chosen: (serv.is_chosen && serv.value_chosen) ? serv.value_chosen : 0,
      }));
    },

    setServicesPrice({ services, exclTax }: { services: Service[]; exclTax: boolean }) {
      this.servicesPrice = servicesHelper.getPrice(services, exclTax);
    },
  },
});
